import { render } from "./LanguageToggle.vue?vue&type=template&id=ffe31fa2&scoped=true"
import script from "./LanguageToggle.vue?vue&type=script&lang=js"
export * from "./LanguageToggle.vue?vue&type=script&lang=js"

import "./LanguageToggle.vue?vue&type=style&index=0&id=ffe31fa2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffe31fa2"]])

export default __exports__